import { render, staticRenderFns } from "./ProductsCard.vue?vue&type=template&id=215df5c7&scoped=true"
import script from "./ProductsCard.vue?vue&type=script&lang=js"
export * from "./ProductsCard.vue?vue&type=script&lang=js"
import style0 from "./ProductsCard.vue?vue&type=style&index=0&id=215df5c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215df5c7",
  null
  
)

export default component.exports